import { useEffect, useState } from 'react';
import { logDataModels } from '../dataModelsLogger';
import {
  EMPTY_POLICY_DIRECTORY,
  loadPolicyDirectory,
  type PolicyDirectory,
} from './policyDirectory';

export function usePolicyDirectory(): PolicyDirectory & { loading: boolean; error: string } {
  const [directory, setDirectory] = useState<PolicyDirectory>(EMPTY_POLICY_DIRECTORY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    loadPolicyDirectory()
      .then((next) => {
        if (cancelled) return;
        setDirectory(next);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const message = err instanceof Error ? err.message : 'Unable to load people, roles, and groups';
        setDirectory(EMPTY_POLICY_DIRECTORY);
        setError(message);
        logDataModels('error', 'policy_directory_hook_failed', { message });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { ...directory, loading, error };
}
